import escapeRegExp from "lodash/escapeRegExp";

export const searchPhrasesFromText = ({ searchText }) => {
  // Function that lowercases the searchText and separates phrases surrounded by quotes and those that aren't.
  const regex = new RegExp("\"(.*?)\"", "gi");
  const fullPhraseMatchByIndex = {};
  const multiWordSearchPhrases = [];
  let result;

  while ((result = regex.exec(searchText))) {
    multiWordSearchPhrases.push(result[1].trim().replace(/\s+/g, " "));
    fullPhraseMatchByIndex[result.index] = result[0];
  }

  let updatedSearchText = searchText;
  Object.keys(fullPhraseMatchByIndex).forEach(indexAsString => {
    const index = parseInt(indexAsString);
    const fullMatchLength = fullPhraseMatchByIndex[index].length;

    const firstPortion = updatedSearchText.substring(0, index);
    const replacedPortion = " ".repeat(fullMatchLength);
    const endPortion = updatedSearchText.substring(index + fullMatchLength, updatedSearchText.length);

    updatedSearchText = firstPortion + replacedPortion + endPortion;
  });

  const singlePhrases = updatedSearchText.split(/\s+/);
  const nonEmptyPhrases = (multiWordSearchPhrases.concat(singlePhrases)).filter(word => word.length > 0);
  return nonEmptyPhrases.map(phrase => escapeRegExp(phrase));
};
